import { BasicRequest } from "./basicRequest";

export class UndeleteUserRequest extends BasicRequest{

    public userId! : number;

    constructor(){
        super();
    }
}